/**
 * Resolves the Square environment with a hostname guard.
 * dev.tumbyfc.com always forces sandbox regardless of env vars (Requirement 12.3).
 */
export type SquareEnv = 'sandbox' | 'production';

export function resolveSquareEnv(): SquareEnv {
  if (typeof window !== 'undefined' && window.location.hostname === 'dev.tumbyfc.com') {
    return 'sandbox';
  }
  return import.meta.env.VITE_SQUARE_ENVIRONMENT === 'production' ? 'production' : 'sandbox';
}

export function isSandbox(): boolean {
  return resolveSquareEnv() === 'sandbox';
}
